import React from "react";
import { Row, Col } from "@zendeskgarden/react-grid";
import {
  Field,
  Input,
  Label,
  Toggle,
  Message,
  MediaInput,
  Hint,
} from "@zendeskgarden/react-forms";
import {
  Dropdown,
  Field as DropdownField,
  Item,
  Menu,
  Select,  
} from "@zendeskgarden/react-dropdowns";
import { AuthenticationService } from "../../../services/auth.service";
import Modal from "react-bootstrap/Modal";
import { Datepicker } from "@zendeskgarden/react-datepickers";
import { ThemeProvider } from "@zendeskgarden/react-theming";
import { theme } from "../../../util/colorButton";
import Header from "../../../components/header";
import Loading from "../../../components/loading";
import UserService from "../../../services/user.service";
import TranslationService, { t } from "../../../translations/translation.service";
import { UserData } from "../../../model/user.model";
import { ReactComponent as LockIcon } from "@zendeskgarden/svg-icons/src/16/lock-locked-fill.svg";
import { ReactComponent as UnlockIcon } from "@zendeskgarden/svg-icons/src/16/lock-unlocked-fill.svg";
import "./index.css";
import { AlertService } from "../../../services/alert.service";
import Phone from "../view/components/phone/phone";
import AzureCitySelect from "../view/components/maps/AzureCitySelect";

class PersonalInformation extends React.Component<any> {
  constructor(props: any) {
    super(props);
    this.handleResize = this.handleResize.bind(this);
    this.dateFormat = this.dateFormat.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleLocation = this.handleLocation.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handlePcd = this.handlePcd.bind(this);
    this.submitInfo = this.submitInfo.bind(this);
    this.parseDateBr = this.parseDateBr.bind(this);
    this.handleTipoDeficiencia = this.handleTipoDeficiencia.bind(this);
  }

  state = {
    screenWidth: window.innerWidth,
    redefinePasswordModal: false,
    user: {} as UserData | any,
    dataNascimento: new Date(),
    loading: false,
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    verify: false,
    showCurrentPassword: false,
    showNewPassword: false,
    showConfirmPassword: false,
    dropdownAberto: false,
    phoneValue: "",
    phoneCountry: "",
    phoneTouched: false,
    phoneInputError: "", 
  };

  handleResize() {
    this.setState({ screenWidth: window.innerWidth });
  }

  dateFormat() {
    const dateFormatter = new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    return dateFormatter;
  }

  parseDateBr(inputValue: string) {
    if (inputValue.length === 10) {
      const value = inputValue.split("/");
      const formatDateBR = `${value[1]}/${value[0]}/${value[2]}`;
      const data = new Date(formatDateBR);
      return data;
    }
    return new Date(this.state.user?.dadosPessoais?.dataNascimento || "");
  }

  handleChange(event: any | string) {
    const { target } = event;
    const { name } = target;
    const userInfo = this.state.user;
    const findKey = Object.keys(userInfo).find((key) => key === name);
    const isToggle = Object.keys(event.target).find((key) => key === "checked");
    if (findKey) {
      if (isToggle) {
        userInfo[name] = target.checked;
      } else {
        userInfo[name] = target.value;
      }
      this.setState({
        user: userInfo,
      });
    } else {
      userInfo.dadosPessoais[name] = target.value;
      this.setState({
        user: userInfo,
      });
    }
  }
  
  handlePcd(event: any) {
    const userInfo = this.state.user;
    if (!userInfo.dadosPessoais.pcdUser) {
      userInfo.dadosPessoais.pcdUser =
        {} as UserData["dadosPessoais"]["pcdUser"];
    }
    userInfo.dadosPessoais.pcdUser.isUserPCD = event.target.checked;
    this.setState({ user: userInfo });
  }

  handleTipoDeficiencia(item: any) {
    this.setState((prevState: any) => {
      const user = { ...prevState.user };
      if (!user.dadosPessoais) user.dadosPessoais = {};
      if (!user.dadosPessoais.pcdUser) user.dadosPessoais.pcdUser = {};
      let tipos = user.dadosPessoais.pcdUser.defs ?? [];
      if (tipos.some((t: any) => t.value === item.value)) {
        tipos = tipos.filter((t: any) => t.value !== item.value);
      } else {
        tipos = [...tipos, item];
      }
      user.dadosPessoais.pcdUser.defs = tipos;
      return { user };
    });
  }

  handleCid = (e: any) => {
    this.setState((prevState: any) => {
      const user = { ...prevState.user };
      user.dadosPessoais = user.dadosPessoais || {};
      user.dadosPessoais.pcdUser = user.dadosPessoais.pcdUser || {};
      user.dadosPessoais.pcdUser.cidCode = e.target.value;
      return { user };
    });
  }

  handleLocation(location: any) {
    if (!location) {
      return;
    }
    this.setState((prevState: any) => {
    const userInfo = { ...prevState.user };
     if (!userInfo.dadosPessoais) userInfo.dadosPessoais = {};
    userInfo.dadosPessoais.geolocation = location;
    if (location && typeof location === 'object') {
      userInfo.dadosPessoais.geolocation_formatted = location.label;
    }
    this.setState({ user: userInfo });
    return { user: userInfo };
  });
 }

  handleSelect(item: string) {
    const userInfo = this.state.user;
    userInfo.dadosPessoais.genero = item;
    this.setState({ user: userInfo });
  }

  checkBlankFields() {
    const { firstName, lastName, email, dadosPessoais } = this.state.user;
    const blankField = (
        firstName === '' ||
        lastName === '' ||
        email === '' ||
        dadosPessoais.geolocation?.label === undefined
      )
    return blankField
  }

 async submitInfo() {
  this.setState({ loading: true });
  delete this.state.user.password;

  const blankField = this.checkBlankFields();
  if (blankField) {
    this.setState({ loading: false });
    return AlertService.error(
      t("(Nome - Sobrenome - email - Localidade) devem ser preenchidos")
    );
  }
    if (this.state.phoneInputError) {
      this.setState({ loading: false });
      return AlertService.error(this.state.phoneInputError);
        }

  try {
    const resp = await UserService.updateUser(this.state.user);
    await UserService.changePcdStatus(
      this.state.user._id,
      this.state.user.dadosPessoais
    );

    this.setState({ user: resp.data, loading: false });
    AlertService.success("Informações alteradas com sucesso");
  } catch (err: any) {
    this.setState({ loading: false });
    if (err.response?.data?.message === "EMAIL_ALREADY_REGISTERED") {
      AlertService.error(t("E-mail já está cadastrado"));
    } else {
      AlertService.error("Não foi possível alterar as informações");
      console.log("erro: ", err.response);
    }
  }
}

  async changePassword() {
    if (this.state.newPassword === this.state.confirmPassword) {
      this.setState({ verify: true });
     try {
    await UserService.changePassword({
      currentPassword: this.state.currentPassword,
      newPassword: this.state.newPassword,
      verifyPassword: this.state.confirmPassword,
    });
    this.setState({ redefinePasswordModal: false, verify: false });
     AlertService.success("Senha alterada com sucesso!");
      } catch(error) {
   AlertService.error("Não foi possível alterar a senha!");
   console.log("Error: ", error);
}
    } else {
      this.setState({ verify: true });
    }
  }

  async componentDidMount() {
    const { id } = this.props.match.params;
    if (AuthenticationService.getUser()._id !== id) {
      this.props.history.push("/login");
    }
    this.setState({ loading: true })
    UserService.getUserWithOpportunities(id)
      .then((resp) => {
        const user = resp.data.user;
        const telefoneObj = user?.contato?.lista?.find((c: any) => c.tipo === "Telefone");
        let phoneValue = "";
        let phoneCountry = "";
        if (telefoneObj?.contato) {
          phoneValue = telefoneObj.contato.startsWith('+') ? telefoneObj.contato.substring(1) : telefoneObj.contato;
          if (telefoneObj.pais) {
            phoneCountry = telefoneObj.pais.toLowerCase();
          }
        }
        this.setState(
          {
            user,
            phoneValue,
            phoneCountry,
          },
          () => {
            const userInfo = this.state.user;
            if (!userInfo.dadosPessoais) {
              userInfo.dadosPessoais = {} as UserData["dadosPessoais"];
            }
              const contato = this.state.user?.contato?.lista;
              if (!contato) {
                this.setState((prevState: any) => {
                  const user = { ...prevState.user };
                  user.contato = user.contato || {};
                  user.contato.lista = [];
                  return { user };
                });
              }
            const birthday1 = Date.parse(
              this.state.user?.dadosPessoais?.dataNascimento
            );
            if (birthday1) {
              this.setState({ dataNascimento: new Date(birthday1), loading: false });
            } else {
              this.setState({ dataNascimento: '', loading: false });
            }
          }
        );
      })
      .catch((err) => console.error(err));
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.addEventListener("resize", this.handleResize);
  }

  render() {
    return (
      <div className="pi-container">
        <ThemeProvider theme={theme as any}>
          <Loading show={this.state.loading} />
          <h6 className="main-title mb-4">{t("Informações Pessoais")}</h6>
          <Row className="row justify-content-center pi-container-1">
            <Col>
              <Row className="mb-3 pi-container-1">
                <Col>
                  <Field>
                    <Label style={{ width: "100%" }} className="text-label">
                      <span className="text-label">{t("Nome")}</span>
                      <Input
                        value={this.state.user.firstName}
                        name="firstName"
                        className="mt-2"
                        onChange={this.handleChange}
                      />
                    </Label>
                  </Field>
                </Col>
                <Col>
                  <Field>
                    <Label style={{ width: "100%" }} className="text-label">
                      <span className="text-label">{t("Sobrenome")}</span>
                      <Input
                        name="lastName"
                        value={this.state.user.lastName}
                        className="mt-2"
                        onChange={this.handleChange}
                      />
                    </Label>
                  </Field>
                </Col>
                <Col>
                  <Field>
                    <Label style={{ width: "100%" }}>
                      <span className="text-label">
                        {t("Data de Nascimento")}
                      </span>
                      <Datepicker
                        maxValue={new Date()}
                        value={this.state.dataNascimento}
                        onChange={(date) =>
                          this.setState({ dataNascimento: date }, () => {
                            const userInfo = this.state.user;
                            userInfo.dadosPessoais.dataNascimento = new Date(
                              date
                            ).toISOString();
                            this.setState({ user: userInfo });
                          })
                        }
                        formatDate={(date) => this.dateFormat().format(date)}
                        customParseDate={this.parseDateBr}
                        locale="pt-BR"
                      >
                        <Input className="mt-2" />
                      </Datepicker>
                      <Hint style={{ fontSize: "0.7rem", opacity: 0.8 }}>
                        {t("formato dd/mm/yyyy")}
                      </Hint>
                    </Label>
                  </Field>
                </Col>
              </Row>
              <Row className="mb-3 pi-container-1">
                <Col>
                  <Field>
                    <Label style={{ width: "100%" }} className="text-label">
                      <span className="text-label">E-mail</span>
                      <Input
                        name="email"
                        value={this.state.user.email}
                        className="mt-2"
                        onChange={this.handleChange}
                      />
                    </Label>
                  </Field>
                </Col>
                <Col>
                  <Field>
                    <Label style={{ width: "100%" }}>
                      <p className="text-label mb-2">{t("Localidade")}</p>
                       <AzureCitySelect
                          onChange={this.handleLocation}
                          placeholder="Digite a cidade"
                          currentLanguage={TranslationService.getCurrentLanguage()}
                          value={this.state.user?.dadosPessoais?.geolocation || null}
                      />
                    </Label>
                  </Field>
                </Col>
                <Col>
                  <Field>
                    <Label style={{ width: "100%" }} className="text-label">
                      <p className="text-label mb-2">{t("Telefone")}</p>
                      <Phone
                        user={this.state.user}
                        onChange={(userAtualizado: any) => this.setState({ user: userAtualizado })}
                        onError={(msg: string) => this.setState({ phoneInputError: msg })}
                      />
                    </Label>
                  </Field>
                </Col>
              </Row>
              <Row
                className="mb-3 pi-container-1"
                style={this.state.screenWidth > 800 ? { width: "68%" } : {}}
              >
                <Col>
                  <Field>
                    <Label style={{ width: "100%" }}>
                      {TranslationService.getCurrentLanguage() === "en-US" && (
                        <span className="text-label">NIF / SSN</span>
                      )}
                      {TranslationService.getCurrentLanguage() === "pt-BR" && (
                        <span className="text-label">CPF</span>
                      )}
                      {TranslationService.getCurrentLanguage() === "pt-PT" && (
                        <span className="text-label">NIF</span>
                      )}
                      <Input
                        name="cpf"
                        onChange={this.handleChange}
                        value={this.state.user?.dadosPessoais?.cpf}
                        className="mt-2"
                      />
                    </Label>
                  </Field>
                </Col>
                <Col>
                  <Field>
                    <Label style={{ width: "100%" }} className="mb-2">
                      <p className="text-label mb-2">{t("Gênero")}</p>
                      <Dropdown
                        selectedItem={t(this.state.user?.dadosPessoais?.genero)}
                        onSelect={this.handleSelect}
                        downshiftProps={{
                          itemToString: (item: any) => item,
                        }}
                      >
                        <DropdownField>
                          <Select>
                            {t(this.state.user?.dadosPessoais?.genero)}
                          </Select>
                        </DropdownField>
                        <Menu>
                          <Item value="Masculino">{t("Masculino")}</Item>
                          <Item value="Feminino">{t("Feminino")}</Item>
                          <Item value="Prefiro não responder">
                            {t("Prefiro não responder")}
                          </Item>
                          <Item value="Outros">{t("Outros")}</Item>
                        </Menu>
                      </Dropdown>
                    </Label>
                  </Field>
                 </Col>
                </Row>
               </Col>
          </Row>
            <Row className="mt-2 align-items-end">
              <Col md={6}>
                <Field>
                  <Toggle
                    checked={this.state.user?.dadosPessoais?.pcdUser?.isUserPCD || false}
                    onChange={this.handlePcd}
                    name="pcd"
                  >
                    <Label>
                      <span className="pcd-button">{t("Pessoa com Deficiência")}</span>
                    </Label>
                </Toggle>
                    {this.state.user?.dadosPessoais?.pcdUser?.isUserPCD && (
                  <>
                    <Field className="mt-1 pcd-info">
                      <Dropdown
                        selectedItem={this.state.user?.dadosPessoais?.pcdUser?.defs || []}
                        onSelect={(item) => {
                          this.handleTipoDeficiencia(item);
                          this.setState({ dropdownAberto: true });
                        }}
                        isOpen={this.state.dropdownAberto}
                        downshiftProps={{
                          itemToString: (item: any) => (item ? item.label : ""),
                        }}
                      >
                        <DropdownField
                          onClick={() =>
                            this.setState((prevState: any) => ({
                              dropdownAberto: !prevState.dropdownAberto
                            }))
                          }
                        >
                          <Select>
                            {(this.state.user?.dadosPessoais?.pcdUser?.defs || [])
                              .map((t: any) => t.label)
                              .join(", ") || t("Tipos de Deficiência")}
                          </Select>
                        </DropdownField>
                      <Menu>
                        {[
                          { value: "Visual", label: t("Visual") },
                          { value: "Auditiva", label: t("Auditiva") },
                          { value: "Intelectual", label: t("Intelectual") },
                          { value: "Física", label: t("Física") },
                          { value: "Neurodiversidade", label: t("Neurodiversidade") },
                          { value: "Outros", label: t("Outros") }
                        ].map((opt) => {
                          const isSelected = (
                            this.state.user?.dadosPessoais?.pcdUser?.defs || []
                          ).some((t: any) => t.value === opt.value)
                          return (
                            <Item key={opt.value} value={opt}>
                              <span className={`dropdown-i ${isSelected ? "selected" : ""}`}>
                                <span className="check">✓</span>
                                <span>{opt.label}</span>
                                </span>
                            </Item>
                          );
                        })}
                      </Menu>
                    </Dropdown>
                  </Field>
                  <Field className="mt-1 pcd-info">
                    <Label>{t("Código CID")}</Label>
                    <Input
                      maxLength={50}
                      value={this.state.user?.dadosPessoais?.pcdUser?.cidCode || ""}
                      onChange={this.handleCid}
                    />
                  </Field>
                </>
              )}
              </Field>
              <Field className={`mt-1 ${this.state.user?.dadosPessoais?.pcdUser?.isUserPCD ? "field-extra-spacing" : ""}`}>
                <Toggle
                  checked={this.state.user?.europeanUnionCitizenship || false}
                  onChange={this.handleChange}
                  name="europeanUnionCitizenship"
                >
                  <Label>
                    <span className="pcd-button">
                      {t("Cidadania Europeia")}
                          </span>
                  </Label>
                  </Toggle>
                  </Field>
                  </Col>
            <Col md={6} className="d-flex justify-content-end align-items-end">
              <div className="button-container">
                <button
                  onClick={() => this.setState({ redefinePasswordModal: true })}
                  className="redefine-button"
                >
                  {t("Redefinir senha")}
                </button>
                <button
                  className="save-button"
                  onClick={this.submitInfo}
                >
                  {t("Salvar")}
                </button>
              </div>
            </Col>
        </Row>
          <Row>
            <Col
              className={
                this.state.screenWidth < 800
                  ? "terms-of-use mt-4"
                  : "offset-md-9 terms-of-use mt-4"
              }
            > 
              {TranslationService.getCurrentLanguage() === "en-US" ? (
                <p>
                  By clicking "Save", you accept the Enter{" "}
                  <a href="/terms-of-use">Terms of Use</a>
                </p>
              ) : (
                <p>
                  Ao clicar em "Salvar", você aceita os{" "}
                  <a href="/terms-of-use">Termos de uso</a> do Enter
                </p>
              )}
            </Col>
          </Row>
          {
            // MODAL PARA REDEFINIR SENHA
            this.state.redefinePasswordModal && (
              <Modal
                size={this.state.screenWidth < 400 ? "sm" : undefined }
                centered
                show={this.state.redefinePasswordModal}
                onHide={() =>
                  this.setState({ redefinePasswordModal: false, verify: false })
                }
              >
                <Modal.Header closeButton>
                  <Header />
                </Modal.Header>
                <Modal.Body>
                  <div>
                    <Col className="offset-md-1 mb-4 modal-title">
                      {t("Redefinir senha")}
                    </Col>
                    <Col className="offset-md-1 mb-3">
                      <Field>
                        <Label
                          style={
                            this.state.screenWidth > 767 &&
                            this.state.screenWidth < 800
                              ? { width: "83%" }
                              : this.state.screenWidth < 800
                              ? { width: "100%" }
                              : { width: "83%" }
                          }
                        >
                          <MediaInput
                            type={
                              this.state.showCurrentPassword
                                ? "text"
                                : "password"
                            }
                            end={
                              this.state.showCurrentPassword ? (
                                <UnlockIcon
                                  cursor={"pointer"}
                                  onClick={() =>
                                    this.setState({
                                      showCurrentPassword: false,
                                    })
                                  }
                                />
                              ) : (
                                <LockIcon
                                  cursor={"pointer"}
                                  onClick={() =>
                                    this.setState({ showCurrentPassword: true })
                                  }
                                />
                              )
                            }
                            placeholder={
                              TranslationService.getCurrentLanguage() ===
                              "en-US"
                                ? "Current Password"
                                : "Senha Atual"
                            }
                            onChange={(event) =>
                              this.setState({
                                currentPassword: event.target.value,
                              })
                            }
                          />
                        </Label>
                      </Field>
                    </Col>
                    <Col className="offset-md-1 mb-3">
                      <Field>
                        <Label
                          style={
                            this.state.screenWidth > 767 &&
                            this.state.screenWidth < 800
                              ? { width: "83%" }
                              : this.state.screenWidth < 800
                              ? { width: "100%" }
                              : { width: "83%" }
                          }
                        >
                          <MediaInput
                            type={
                              this.state.showNewPassword ? "text" : "password"
                            }
                            end={
                              this.state.showNewPassword ? (
                                <UnlockIcon
                                  cursor={"pointer"}
                                  onClick={() =>
                                    this.setState({ showNewPassword: false })
                                  }
                                />
                              ) : (
                                <LockIcon
                                  cursor={"pointer"}
                                  onClick={() =>
                                    this.setState({ showNewPassword: true })
                                  }
                                />
                              )
                            }
                            placeholder={
                              TranslationService.getCurrentLanguage() ===
                              "en-US"
                                ? "New Password"
                                : "Nova Senha"
                            }
                            onChange={(event) =>
                              this.setState({
                                newPassword: event.target.value,
                              })
                            }
                            validation={
                              this.state.verify
                                ? this.state.newPassword ===
                                  this.state.confirmPassword
                                  ? "success"
                                  : "error"
                                : undefined
                            }
                          />
                        </Label>
                      </Field>
                    </Col>
                    <Col className="offset-md-1 mb-3">
                      <Field>
                        <Label
                          style={
                            this.state.screenWidth > 767 &&
                            this.state.screenWidth < 800
                              ? { width: "83%" }
                              : this.state.screenWidth < 800
                              ? { width: "100%" }
                              : { width: "83%" }
                          }
                        >
                          <MediaInput
                            type={
                              this.state.showConfirmPassword
                                ? "text"
                                : "password"
                            }
                            end={
                              this.state.showConfirmPassword ? (
                                <UnlockIcon
                                  cursor={"pointer"}
                                  onClick={() =>
                                    this.setState({
                                      showConfirmPassword: false,
                                    })
                                  }
                                />
                              ) : (
                                <LockIcon
                                  cursor={"pointer"}
                                  onClick={() =>
                                    this.setState({ showConfirmPassword: true })
                                  }
                                />
                              )
                            }
                            placeholder={
                              TranslationService.getCurrentLanguage() ===
                              "en-US"
                                ? "Comfirm"
                                : "Confirmação"
                            }
                            onChange={(event) =>
                              this.setState({
                                confirmPassword: event.target.value,
                              })
                            }
                            validation={
                              this.state.verify
                                ? this.state.newPassword ===
                                  this.state.confirmPassword
                                  ? "success"
                                  : "error"
                                : undefined
                            }
                          />
                          <Message
                            validation={
                              this.state.verify
                                ? this.state.newPassword ===
                                  this.state.confirmPassword
                                  ? "success"
                                  : "error"
                                : undefined
                            }
                          >
                            {this.state.verify
                              ? this.state.newPassword ===
                                this.state.confirmPassword
                                ? "OK"
                                : "Senhas não conferem"
                              : undefined}
                          </Message>
                        </Label>
                      </Field>
                    </Col>
                    <Col className="offset-md-1">
                      <Label
                        style={
                          this.state.screenWidth > 767 &&
                          this.state.screenWidth < 800
                            ? { width: "83%" }
                            : { width: "100%" }
                        }
                      >
                        <button
                          disabled={
                            this.state.newPassword.length < 6 ||
                            this.state.confirmPassword.length < 6 ||
                            this.state.currentPassword === ""
                              ? true
                              : false
                          }
                          className="modal-save-button"
                          style={
                            this.state.newPassword.length < 6 ||
                            this.state.confirmPassword.length < 6 ||
                            this.state.currentPassword === ""
                              ? { backgroundColor: "#B9B9B9" }
                              : { backgroundColor: "#DE701D" }
                          }
                          onClick={this.changePassword.bind(this)}
                        >
                          {t("Redefinir senha")}
                        </button>
                      </Label>
                    </Col>
                  </div>
                </Modal.Body>
                <Modal.Footer className="col justify-content-center mb-1">
                  <Col
                    className={
                      this.state.screenWidth < 800
                        ? ""
                        : "text-center ml-5 mr-5 pl-5 pr-5"
                    }
                  >
                    {TranslationService.getCurrentLanguage() === "en-US" ? (
                      <p className="privacy-policy">
                        We are very careful with your data. See our{" "}
                        <a href="/terms-of-use">Privacy Policy</a>
                      </p>
                    ) : (
                      <p className="privacy-policy">
                        Somos muito cuidadosos com seus dados. Veja nossa{" "}
                        <a href="/terms-of-use">Política de Privacidade</a>
                      </p>
                    )}
                  </Col>
                </Modal.Footer>
              </Modal>
            )
          }
        </ThemeProvider>
      </div>
    );
  }
}

export default PersonalInformation;